import { Popover } from "components/Popover/Popover";
import { useState } from "react";
import styles from "./ColorPicker.module.scss";

interface ColorPickerProps {
    color: string;
    onChange: (changedColor: string) => void;
    isReadOnly?: boolean;
}
const presetColors = [
    "#FFFFFF",
    "#FFFFDF",
    "#FFF280",
    "#FFC107",
    "#FFB3BF",
    "#FF758F",
    "#F44336",
    "#DC96E8",
    "#DAF7A6",
    "#D5B9B2",
    "#CED4DA",
    "#C6AC8F",
    "#C2C2FF",
    "#8BC34A",
    "#74D5FB",
    "#2196F3",
    "#03A9F4",
    "#00BCD4",
    "#009688",
];

export const ColorPicker = ({ color, onChange, isReadOnly }: ColorPickerProps) => {
    const [isOpened, setOpened] = useState(false);

    return (
        <Popover
            trigger={
                <div
                    onClick={(event) => {
                        if (isReadOnly) return;
                        setOpened(true);
                        event.stopPropagation();
                    }}
                    className={styles.ColorPicker}
                    style={{
                        background: color,
                    }}
                />
            }
            contentClassName={styles.ColorPickerPopover}
            closeOnInsideClick={false}
            isOpen={isOpened}
            closeHandler={() => {
                setOpened(false);
            }}
            rootClassName={styles.ColorPickerPopoverOverlay}
        >
            <div className="colorPalette">
                {presetColors.map((presetColor) => (
                    <div
                        className={`presetColor ${presetColor === color ? "active" : ""} `}
                        key={presetColor}
                        style={{
                            background: presetColor,
                        }}
                        onClick={() => {
                            onChange(presetColor);
                            setOpened(false);
                        }}
                    />
                ))}
            </div>
        </Popover>
    );
};
// };
